<template>
  <section
    v-if="customRestOauthNotificationVisible"
    :class="$style.notificationWrapper"
  >
    <NotificationInPage
      actionText="Got it"
      :notification="customRestOauthNotification"
      @action="handleDismissClick"
    />
  </section>
</template>

<script>
import { NotificationInPage, Types } from '@jumpcloud/ui-components';
import DateUtil from 'client/util/DateUtil';
import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';
import LocalStorageService from 'client/util/LocalStorageService';

const { NotificationConfig } = Types;

export default {
  name: 'IdmOauthImportBanner',

  components: {
    NotificationInPage,
  },

  data() {
    const message = '**New!** Use OAuth 2.0 when configuring generic Identity Management Integrations. Click **Configure>Identity Management>Custom API** or read [Importing Users From A Custom REST API Integration](https://support.jumpcloud.com/support/s/article/Import-users-from-a-custom-rest-API-integration) to get started.';

    const customRestOauthNotification = new NotificationConfig({
      emoji: '📌',
      isMarkdown: true,
      isSingleLineAction: true,
      message,
    });

    const {
      idmCustomRestOauthAppCatalogueDismissed: customOauthBannerLocalStorageKey,
    } = LocalStorageConstants;

    const customRestOauthNotificationDatesRange = {
      startDate: '2022-09-27',
      endDate: '2022-10-15',
    };

    return {
      customOauthBannerLocalStorageKey,
      customRestOauthNotification,
      customRestOauthNotificationDatesRange,
      customRestOauthNotificationVisible: true,
    };
  },

  mounted() {
    this.handleIdmBannerVisibility();
  },

  methods: {
    handleDismissClick() {
      const { setItem } = LocalStorageService;
      setItem(this.customOauthBannerLocalStorageKey, 'seen');
      this.customRestOauthNotificationVisible = false;
    },

    handleIdmBannerVisibility() {
      // LocalStorage constant is not present
      const { getItem } = LocalStorageService;
      const wasBannerSeen = (getItem(this.customOauthBannerLocalStorageKey) === 'seen');

      // Current date should be withing date range
      const {
        startDate,
        endDate,
      } = this.customRestOauthNotificationDatesRange;

      const isValidDate = DateUtil.isInDateRange(startDate, endDate);

      this.customRestOauthNotificationVisible = !wasBannerSeen && isValidDate;
    },
  },
};
</script>

<style module>
.notificationWrapper {
  margin: 0 var(--asideSpacing) var(--asideSpacing);
  width: inherit;
}
</style>
